import type { ReactElement } from "react";

import { useDispatch, useSelector } from "react-redux";

import { ResultsSearchRow } from "app/pages/sales-intelligence/common-components/search-results-table";
import { findAppsUpdateSearchText } from "app/pages/sales-intelligence/store/find-apps/action-creators";
import { selectActiveAppSourceType, selectAppsSearchText } from "app/pages/sales-intelligence/store/find-apps/selectors";
import type { Translatable } from "app/pages/sales-intelligence/types";

const PLACEHOLDER: Translatable = {
    key: "si.find_apps.table.search.placeholder",
};

type Props = {
    isDisabled?: boolean;
};

const SearchRowContainer = ({ isDisabled }: Props): ReactElement => {
    const dispatch = useDispatch();

    const searchText = useSelector(selectAppsSearchText);
    const activeAppSourceType = useSelector(selectActiveAppSourceType);

    const handleSearch = (text: string): void => {
        dispatch(findAppsUpdateSearchText([activeAppSourceType, text]));
    };

    return (
        <ResultsSearchRow
            isDisabled={isDisabled}
            searchText={searchText}
            placeholder={PLACEHOLDER}
            onSearch={handleSearch}
        />
    );
};

export default SearchRowContainer;
